import { useQueryClient } from "@tanstack/react-query";

import { createApiMutationHook, IApiMutationFunction } from "../../utils";
import { CERTIFICATION_ISSUER_LIST_QUERY_KEY } from "../certificationIssuerQueryKey";

export function createCertificationIssuerMutationHook<TParameters, TResult>(
    mutation: IApiMutationFunction<TParameters>,
) {
    const useApiMutation = createApiMutationHook<TParameters, TResult>(mutation);

    return function useCertificationIssuerMutation(options: NonNullable<Parameters<typeof useApiMutation>[0]> = {}) {
        const queryClient = useQueryClient();
        const { onSuccess, ...mutationOptions } = options;

        return useApiMutation({
            ...mutationOptions,
            onSuccess: async (data, variables, context) => {
                await queryClient.invalidateQueries({ queryKey: CERTIFICATION_ISSUER_LIST_QUERY_KEY });
                await onSuccess?.(data, variables, context);
            },
        });
    };
}
